import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {ForgotPasswordConfirmLegacy, ForgotPasswordConfirmLegacyParams} from 'domain/usecases';

export class RemoteForgotPasswordConfirmLegacy implements ForgotPasswordConfirmLegacy {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async forgotPasswordConfirmLegacy({
		signal,
		...params
	}: ForgotPasswordConfirmLegacyParams): Promise<void> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
